import { getOptimizedImages } from 'common/hooks/use-optimized-images';
import { parseFloatValue, stringIsNumber } from 'utils';
import { AxisPoint, PointData } from './types';

export const sortAxis = (poa: PointData[]): AxisPoint[] => {
  return processAxisPoints(poa);
};

export const processAxisPoints = (pointsOnAxis: PointData[]): AxisPoint[] => {
  let isSortByAxis = true;

  const axisPoints = pointsOnAxis.map((pointData) => {
    if (!stringIsNumber(pointData.label)) {
      isSortByAxis = false;
    }

    const optimizedThumb = getOptimizedImages(pointData.mainPhoto, {
      thumb: {
        w: '42',
        h: '42',
      },
    });

    return {
      axis: pointData.axis,
      src: optimizedThumb.thumb.xx || '',
      toProductUrl: pointData.toProductUrl,
      label: pointData.label,
      isPuncturedPoint: pointData.isPuncturedPoint,
      displayedName: pointData.displayedName,
      productPrice: pointData.productPrice,
      productId: pointData.productId,
      productBelong: pointData.productBelong,
    };
  });

  if (isSortByAxis) {
    axisPoints.sort((a, b) => parseFloatValue(a.label) - parseFloatValue(b.label));
  } else {
    axisPoints.sort((a, b) => Number(a.productId) - Number(b.productId));
  }

  return axisPoints;
};
